import React, { useState } from 'react';
import './App.css';

// Component Imports
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Products from './components/Products';
import WhyUs from './components/WhyUs';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import QuoteModal from './components/QuoteModal';

function App() {
    // State to manage which product is being quoted
    const [selectedProduct, setSelectedProduct] = useState(null);

    // Handlers
    const handleQuoteRequest = (product) => {
        setSelectedProduct(product);
    };

    const handleCloseModal = () => {
        setSelectedProduct(null);
    };

    return (
        <div className="App">
            <Navbar />
            <Hero />
            
            <main>
                <About />
                {/* We pass the state setter function down as a prop */}
                <Products onQuoteRequest={handleQuoteRequest} />
                <WhyUs />
                <Testimonials />
                <Contact />
            </main>

            <Footer />

            {/* Logical AND: Only renders the modal if selectedProduct is not null */}
            {selectedProduct && (
                <QuoteModal 
                    product={selectedProduct} 
                    onClose={handleCloseModal} 
                />
            )}
        </div>
    );
}

export default App;